export default class CartRemoveButton extends HTMLElement {
  private cartItems: Element | null = null;
  private warrantyItem: Element | null = null;
  private itemKey: string | null = null;

  constructor() {
    super();
    this.initializeElements();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  private initializeElements(): void {
    this.cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    this.warrantyItem = this.cartItems?.querySelector('[id^="warranty-item"]');
    this.itemKey = this.dataset.itemKey;
  }

  private handleClick(event: Event): void {
    event.preventDefault();

    if (!this.cartItems) {
      return;
    }

    try {
      // Remove associated warranty items if they exist
      if (this.warrantyItem?.getAttribute('data-linked-item-key') == this.itemKey) {
        const variantId = this.dataset.variantId;
        if (!variantId) {
          return;
        }

        this.removeWarrantyItem(variantId, event);
      } else {
        // Remove the main cart item
        this.removeCartItem(event);
      }
    } catch {
      const lineItemErrors = document.querySelectorAll(`#CartItem-LineItemError-${this.dataset.index}`);

      lineItemErrors.forEach((lineItemError) => {
        const errorText = lineItemError?.querySelector('.cart-item__error-text');
        if (errorText) {
          errorText.textContent = 'There was a problem removing the warranty item';
        }
      });
    }
  }

  private removeCartItem(event: Event): void {
    const index = this.dataset.index;

    if (!this.itemKey) {
      return;
    }

    if (typeof this.cartItems?.updateQuantity === 'function') {
      this.cartItems.updateQuantity(index, 0, event, this.itemKey);
    }
  }

  private removeWarrantyItem(variantId: string, event: Event): void {
    const hiddenWarrantyItem = document.querySelector(`#hidden-warranty-item-${variantId}`);
    if (!hiddenWarrantyItem) {
      return;
    }

    const itemIndex = this.dataset.index;
    const warrantyKey = hiddenWarrantyItem.dataset.itemKey;

    if (!warrantyKey || !this.itemKey) {
      return;
    }

    if (typeof this.cartItems?.updateQuantity === 'function') {
      this.cartItems.removeWarrantyAndItemQuantity(itemIndex, this.itemKey, warrantyKey, event, variantId);
    }
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}
